import { BREAKPOINTS } from '../utils/constatns';

if (!customElements.get('topbar-text-list')) {
    class TopbarTextList extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.selectors = {
                sliderWrapper: '.topbar-text-list__items',
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            };

            this.classes = {
                swiper: 'swiper',
                swiperWrapper: 'swiper-wrapper',
            };

            this.sectionId = this.dataset.sectionId;
            this.section = this.closest(`.section-${this.sectionId}`);
            this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
            this.sliderWidth = this.dataset.sliderWidth && this.dataset.sliderWidth !== '0' ? `${this.dataset.sliderWidth}px` : '100%';
            
            this.sliderInstance = false;
            this.visibilityObserver = null;

            this.mqlMobile = window.matchMedia(FoxTheme.config.mediaQueryMobile);
            this.mqlMobile.onchange = this.handleBreakpointChange.bind(this);
            
            this.init();
        }

        disconnectedCallback() {
            if (this.mqlMobile) this.mqlMobile.onchange = null;
            this.destroyVisibilityObserver();
            this.destroySlider();
        }

        handleBreakpointChange() {
            this.destroySlider();
            this.init();
        }

        init() {
            this.initSlider();
        }

        initSlider() {
            if (window.innerWidth < BREAKPOINTS.md || this.sliderWidth === '0') {
                this.style.maxWidth = '100%';
            } else {
                this.style.maxWidth = this.sliderWidth;
            }

            const autoSlide = this.dataset.autoSlide === 'true';
            const autoSlideSeconds = parseInt(this.dataset.autoSlideSeconds, 10) || 5;
            const modules = [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Mousewheel, FoxTheme.Swiper.EffectFade];
            if (autoSlide) {
                modules.push(FoxTheme.Swiper.Autoplay);
            }

            const sliderOptions = {
                modules,
                spaceBetween: 0,
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                speed: 300,
                navigation: {
                    nextEl: this.querySelector(this.selectors.nextEl),
                    prevEl: this.querySelector(this.selectors.prevEl),
                },
                pagination: false,
                loop: true,
                threshold: 2,
                mousewheel: {
                    enabled: true,
                    forceToAxis: true,
                },
                ...(autoSlide && {
                    autoplay: {
                        delay: autoSlideSeconds * 1000,
                        disableOnInteraction: false,
                    },
                }),
            };

            if (typeof this.sliderInstance !== 'object') {
                this.classList.add(this.classes.swiper);
                this.sliderWrapper.classList.add(this.classes.swiperWrapper);

                this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
                this.sliderInstance.init();

                const focusableElements = FoxTheme.a11y.getFocusableElements(this);

                focusableElements.forEach((element) => {
                    element.addEventListener('focusin', () => {
                        const slide = element.closest('.swiper-slide');
                        this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
                    });
                });

                if (Shopify.designMode) {
                    document.addEventListener('shopify:block:select', (e) => {
                        if (e.detail.sectionId != this.sectionId) return;
                        let { target } = e;
                        console.log('target: ', target)
                        const index = Number(target.dataset.index);
                        console.log('index: ', index)
                        this.sliderInstance.slider.slideTo(index);
                    });
                }

                if (autoSlide && this.sliderInstance?.slider?.autoplay) {
                    this.setupVisibilityObserver();
                }
            }
        }

        setupVisibilityObserver() {
            this.destroyVisibilityObserver();
            this.visibilityObserver = new IntersectionObserver(
                (entries) => {
                    const entry = entries[0];
                    if (!entry || typeof this.sliderInstance?.slider?.autoplay === 'undefined') return;
                    const swiper = this.sliderInstance.slider;
                    if (entry.isIntersecting) {
                        swiper.update();
                        swiper.autoplay.start();
                    } else {
                        swiper.autoplay.stop();
                    }
                },
                { threshold: 0.01, rootMargin: '0px' }
            );
            this.visibilityObserver.observe(this);
        }

        destroyVisibilityObserver() {
            if (this.visibilityObserver) {
                this.visibilityObserver.disconnect();
                this.visibilityObserver = null;
            }
        }

        destroySlider() {
            this.destroyVisibilityObserver();
            this.classList.remove(this.classes.swiper);
            this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
            if (typeof this.sliderInstance !== 'object') return;
            this.sliderInstance.slider.destroy();
            this.sliderInstance = false;
        }
    }
    customElements.define('topbar-text-list', TopbarTextList);
}